import { useHistory } from "react-router-dom";
import { QESButton } from "@app/shared/qes-standards";
import { ImportPageRouter } from "../services";
import { JSX } from "react";

export const ImportStepSettings = (): JSX.Element => {
  const history = useHistory();
  const importPageRouter = new ImportPageRouter();

  const saveStep = () => {
    // TODO: implement saving settings
    importPageRouter.closeSidePanelRoute(history);
  };

  return (
    <div className="d-flex flex-column justify-content-between">
      <div>
        <h5>Edit Step</h5>
      </div>
      <div>
        <QESButton qesTestId="import-step-settings_save" qesType="primary" className="mt-1 mr5" onClick={saveStep}>Save</QESButton>
      </div>
    </div>
  );
};
